import { type Registry as Services, service } from '@ember/service';
import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import { getDemoInfo } from 'frontend-utils/utils/hash';
import type { SmartInsightsPropertyTags } from 'lumen/models';

export default class SmartInsightsHotelModel extends Model {
  [Type] = 'smart-insights/hotel' as const;

  @belongsTo('smart-insights/property-tags', {
    async: false,
    inverse: null,
  })
  declare propertyTags: SmartInsightsPropertyTags;

  @attr('string') declare brandCode: string;
  @attr('boolean') declare hasAccessSmartInsights: boolean;
  // Whether this hotel is on a plan that grants Smart Insights Multi-Property View
  // access (i.e. the "performance plan"). A hotel can have `hasAccessSmartInsights`
  // without this, e.g. an SPV-only plan.
  @attr('boolean') declare hasSiMpv: boolean;
  @attr('string') declare hotelinfoId: string;
  @attr('string') declare hotelinfoName: string; // Note: use `hotelName` instead of `hotelinfoName` because it supports demo mode.
  @attr('string') declare subscriptionId: string;

  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  get displayName(): string {
    return this.brandCode
      ? `${this.brandCode}-${this.hotelinfoName}`
      : this.hotelinfoName;
  }

  get hotelName(): string {
    if (this.hotelAndMarketService.isDemoModeActive) {
      const demoInfo = getDemoInfo(this.hotelinfoName);

      if (!demoInfo) {
        return 'Hotel';
      }

      return `Hotel ${demoInfo.id}`;
    }

    return this.displayName;
  }
}
